import {
  ApplicationDispatch,
  SET_SERVER_MESSAGE
} from "../store/application/types";
import { postData} from "./fetch";
import { IEmailOutbound } from "../Components/Views/OrderEditor/EmailNotifications";

export const sendEmailNotification = async (
  emailOutbound: IEmailOutbound,
  dispatch: ApplicationDispatch
) => {
  const url = `api/emailNotification/sendEmail`;
  try {
    const responseMessage: {message: string, isError: boolean } = await postData(url, emailOutbound);
    
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: {
        message: responseMessage.message,
        isError: responseMessage.isError,
      },
    });      
    
  } catch (error) {
    const msg = `Send Email Failure: ${error}`;
    dispatch({ type: "SET_SERVER_MESSAGE", payload: { message: msg, isError: true } });
  }
}